import { render } from "./BookingsDisplay.vue?vue&type=template&id=72f46be9&scoped=true&ts=true"
import script from "./BookingsDisplay.vue?vue&type=script&lang=ts"
export * from "./BookingsDisplay.vue?vue&type=script&lang=ts"

import "./BookingsDisplay.vue?vue&type=style&index=0&id=72f46be9&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f46be9"]])

export default __exports__